import http from '@/utils/http';

/** 业务字典数据 */
const businessDict = {
  /**
   * 获取字典数据
   * @param groupId 分组ID
   */
  listDict(groupId: string) {
    return http.post('/api/user/businessDict', { groupId });
  },
};

export default businessDict;
